import CommandController from "../shared/command_controller";

export default class extends CommandController {
  connect() {
    console.log(this.typeValue);
    console.log(this.dataValue);
    this.command();
  }
}
